import { PURGE } from "redux-persist";

const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    loginId : 'NONE',
    name : '',
    // subway : null,
    // workingPart : null,
};

const userSlice = createSlice({
    name : 'user',
    initialState,
    reducers : {
        setUser : (state, action) => {
            state.loginId = action.payload.loginId;
            state.name = action.payload.name;
            // state.subway = action.payload.subway;
            // state.workingPart = action.payload.workingPart;
        },
        deleteUser : (state) => {
            state.loginId = 'NONE';
            state.name = '';
            // state.subway = null;
            // state.workingPart = null;
        }
    },
    extraReducers : (builder) => {
        builder.addCase(PURGE, ()=> initialState);
    }
});

export const { setUser, deleteUser } = userSlice.actions;

export default userSlice.reducer;